import _min from "../array/min";
import _values from "./values";
var exports = {};
var arrMin = _min;
var values = _values;
/**
 * Returns minimum value inside object.
 */

function min(obj, iterator) {
  return arrMin(values(obj), iterator);
}

exports = min;
export default exports;